import { render, staticRenderFns } from "./SizeSpinsButton.vue?vue&type=template&id=263c10ee"
import script from "./SizeSpinsButton.vue?vue&type=script&lang=js"
export * from "./SizeSpinsButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports